export const RICH_INLINE_NODE = 'rich_inline';
export const SELECTED_NODE = 'selected';
export const ERROR_NODE = 'error';
